import { SwiperOptions } from "swiper/types";
import { DEFAULT_BREAKPOINTS_CONFIG } from "~/composables/useViewportObserver/config";

export const SPECIAL_ORDERS_SLIDER_OPTIONS: SwiperOptions = {
  direction: "horizontal",
  slidesPerView: "auto",
  spaceBetween: 16,
  grabCursor: true,
  breakpoints: {
    [DEFAULT_BREAKPOINTS_CONFIG.lg]: {
      direction: "vertical",
      height: 1036,
      slidesPerView: 3,
      spaceBetween: 8,
    },
  },
};
